import type { IconSvgObject } from './types';

const Heading03Icon: IconSvgObject = [
  ["path", { d: "M16 12.7778C16 11.6391 16.9588 11 18 11C19.1046 11 20 11.8954 20 13C20 14.5 18.5 15 18.5 15C18.5 15 20 15.5 20 17C20 18.1046 19.1046 19 18 19C16.9588 19 16 18.3609 16 17.2222", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 12H13M4 19V5M13 19V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Heading03Icon;
